import { PropsWithChildren, useState } from "react";
import { DialogResponsive } from "@/components/common/dialogs";
import { Stage } from "@/types";
import { FormStage } from "./form-stage";

type FormStageModalProps = PropsWithChildren & {
  stage?: Stage;
  openDrawer?: boolean;
  disable?: boolean;
};

export function FormStageModal({
  children,
  stage,
  disable
}: FormStageModalProps) {
  const [open, setOpen] = useState(false);
  const handleClose = () => setOpen(false);

  return (
    <DialogResponsive
      title={stage ? "Atualizar estágio" : "Novo estágio"}
      description={
        stage
          ? "Preencha os campos para atualizar o estágio."
          : "Preencha os campos para criar um novo estágio."
      }
      button={children}
      disable={disable}
      defaultOpen={open}
      setDefaultOpen={setOpen}
    >
      <FormStage stage={stage} handleClose={handleClose} />
    </DialogResponsive>
  );
}